// 1. Column Order for Sample Issue
export const sampleIssueDefaultColumnsOrder = [
    "Slno",
    "Code",
    "Description",
    "Unit",
    "Qty",
  ];
  
  // 2. Mapping: Header → Field Name
  export const sampleIssueColumnFieldMap = {
    Slno: "sino",
    Code: "code",
    Description: "description",
    Unit: "unit",
    Qty: "qty",
  };
  
  // 3. Base Column Generator
  export const getSampleIssueBaseColumn = (
    field,
    widthMap,
    renderers,
    locationOptions,
    unitOptions
  ) => {
    const baseConfig = {
      field,
      headerName:
        Object.entries(sampleIssueColumnFieldMap).find(
          ([, value]) => value === field
        )?.[0] || field,
      width: widthMap?.[field] || 100,
      sortable: false,
      filterable: false,
      disableColumnMenu: false,
    };
  
    // Numeric field
    if (field === "qty") {
      return {
        ...baseConfig,
        renderCell: (params) =>
          renderers.renderEditableCell(params, field, "number"),
      };
    }
  
    // Text fields
    if (["code", "description"].includes(field)) {
      return {
        ...baseConfig,
        renderCell: (params) => renderers.renderEditableCell(params, field),
      };
    }
  
    // Location dropdown
    if (field === "location") {
      return {
        ...baseConfig,
        renderCell: (params) =>
          renderers.renderSelectCell(params, "location", locationOptions),
      };
    }
  
    // Unit dropdown
    if (field === "unit") {
      return {
        ...baseConfig,
        renderCell: (params) =>
          renderers.renderSelectCell(params, "unit", unitOptions),
      };
    }
  
    return baseConfig;
  };
  
  // 4. Calculations (minimal - just pass through with validated qty)
  export const calculateSampleIssueRow = (item) => {
    const qty = Number(item.qty) || 0;
  
    return {
      ...item,
      qty,
    };
  };
  
  // 5. Required Fields
  export const sampleIssueRequiredFields = [
    "code",
    "description",
    "location",
    "unit",
    "qty",
  ];
  
  // 6. New Item Template
  export const newSampleIssueItem = (id, sino, defaultLocation) => ({
    id,
    sino,
    code: "",
    description: "",
    location: defaultLocation,
    unit: "",
    qty: 0,
    isIncluded: true,
  });
  
  // 7. Column Width Percent Defaults
  export const sampleIssueColumnPercents = {
    sino: 8,
    code: 15,
    description: 35,
    location: 15,
    unit: 12,
    qty: 15,
  };
  
  const screenCode = "LCATION_TRANSFER";
  
  export const LocationTransferConfig = {
    defaultColumnsOrder: sampleIssueDefaultColumnsOrder,
    columnFieldMap: sampleIssueColumnFieldMap,
    getBaseColumn: getSampleIssueBaseColumn,
    calculateRowValues: calculateSampleIssueRow,
    requiredFields: sampleIssueRequiredFields,
    screenCode,
    newItemTemplate: newSampleIssueItem,
    defaultColumnPercents: sampleIssueColumnPercents,
  };
  
  export default LocationTransferConfig;
  